import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.172 18.344h3.14V9.452h-3.14zm10.42-9.172c-1.302 0-2.011.43-2.829 1.473V9.441H9.645v8.882h3.118v-4.818c0-1.021.495-2.01 1.667-2.01s1.452.989 1.452 2v4.85H19V13.29c0-3.505-2.108-4.107-3.409-4.107zM6.741 5C5.785 5 5 5.699 5 6.57c0 .87.785 1.57 1.742 1.57s1.742-.7 1.742-1.57c0-.86-.785-1.57-1.742-1.57Z"
    }, null, -1)
  ])))
}
export default { render: render }